import { useState } from 'react';
import { Formik, Form } from 'formik';
import { useRouteMatch, useHistory } from 'react-router-dom';
import * as Yup from 'yup';

import PageHeader from '../common/PageHeader';
import SelectField from '../common/SelectField';
import InputField from '../common/InputField';
import ToggleField from '../common/ToggleField';
import Button from '../common/Button';
import Alert from '../common/Alert';
import Snackbar from '../common/Snackbar';

import { parseRequestError } from '../../utils/errors';
import * as apiClient from '../../apiClient';

const vehicleTypes = [
  { label: 'Carro', value: 'carro' },
  { label: 'Moto', value: 'moto' },
  { label: 'Utilitário', value: 'utilitario' },
  { label: 'Caminhão', value: 'caminhao' },
];

const vehicleBrands = [
  { label: 'AUDI A1', value: 'audi a1' },
  { label: 'AUDI A2', value: 'audi a2' },
  { label: 'AUDI A3', value: 'audi a3' },
  { label: 'AUDI A4', value: 'audi a4' },
  { label: 'AUDI A5', value: 'audi a5' },
  { label: 'AUDI A6', value: 'audi a6' },
  { label: 'AUDI A7', value: 'audi a7' },
  { label: 'AUDI A8', value: 'audi a8' },
  { label: 'AUDI ALLROAD', value: 'audi allroad' },
  { label: 'AUDI Q3', value: 'audi q3' },
  { label: 'AUDI Q5', value: 'audi q5' },
  { label: 'AUDI Q7', value: 'audi q7' },
  { label: 'AUDI R8', value: 'audi r8' },
  { label: 'AUDI RS Q3', value: 'audi rs q3' },
  { label: 'AUDI TT', value: 'audi tt' },
  { label: 'AUDI TTS', value: 'audi tts' },
  { label: 'BMW 118I', value: 'bmw 118i' },
  { label: 'BMW 130I', value: 'bmw 130i' },
  { label: 'BMW 135I', value: 'bmw 135i' },
  { label: 'BMW F650', value: 'bmw f650' },
  { label: 'BMW F700 GS', value: 'bmw f700 gs' },
  { label: 'BMW F800', value: 'bmw f800' },
  { label: 'BMW G310', value: 'bmw g310' },
  { label: 'BMW I3', value: 'bmw i3' },
  { label: 'BMW I8', value: 'bmw i8' },
  { label: 'BMW ISETTA', value: 'bmw isetta' },
  { label: 'BMW M2', value: 'bmw m2' },
  { label: 'BMW M3', value: 'bmw m3' },
  { label: 'BMW M4', value: 'bmw m4' },
  { label: 'BMW M5', value: 'bmw m5' },
  { label: 'BMW M6', value: 'bmw m6' },
  { label: 'BMW S 1000 RR', value: 'bmw s 1000 rr' },
  { label: 'BMW X1', value: 'bmw x1' },
  { label: 'BMW X3', value: 'bmw x3' },
  { label: 'BMW X4', value: 'bmw x4' },
  { label: 'BMW X5', value: 'bmw x5' },
  { label: 'BMW X6', value: 'bmw x6' },
  { label: 'BYD DOLPHIN MINI', value: 'byd dolphin mini' },
  { label: 'BYD DOLPHIN', value: 'byd dolphin' },
  { label: 'BYD HAN', value: 'byd han' },
  { label: 'BYD KING', value: 'byd king' },
  { label: 'BYD SEAL', value: 'byd seal' },
  { label: 'BYD SHARK', value: 'byd shark' },
  { label: 'BYD SONG PLUS', value: 'byd song plus' },
  { label: 'BYD TAN', value: 'byd tan' },
  { label: 'BYD YUAN PLUS', value: 'byd yuan plus' },
  { label: 'CHERRY ARRIZO 6', value: 'cherry arrizo 6' },
  { label: 'CHERY QQ', value: 'chery qq' },
  { label: 'CHERY TIGGO', value: 'chery tiggo' },
  { label: 'CHEVROLET AGILE', value: 'chevrolet agile' },
  { label: 'CHEVROLET ASTRA', value: 'chevrolet astra' },
  { label: 'CHEVROLET BLAZER', value: 'chevrolet blazer' },
  { label: 'CHEVROLET CAMARO', value: 'chevrolet camaro' },
  { label: 'CHEVROLET CAPTIVA', value: 'chevrolet captiva' },
  { label: 'CHEVROLET CARAVAN', value: 'chevrolet caravan' },
  { label: 'CHEVROLET CELTA', value: 'chevrolet celta' },
  { label: 'CHEVROLET CHEVETTE', value: 'chevrolet chevette' },
  { label: 'CHEVROLET CLASSIC', value: 'chevrolet classic' },
  { label: 'CHEVROLET COBALT', value: 'chevrolet cobalt' },
  { label: 'CHEVROLET CORSA', value: 'chevrolet corsa' },
  { label: 'CHEVROLET CORVETTE', value: 'chevrolet corvette' },
  { label: 'CHEVROLET CRUZE', value: 'chevrolet cruze' },
  { label: 'CHEVROLET D20', value: 'chevrolet d20' },
  { label: 'CHEVROLET EQUINOX', value: 'chevrolet equinox' },
  { label: 'CHEVROLET GRAND BLAZER', value: 'chevrolet grand blazer' },
  { label: 'CHEVROLET IPANEMA', value: 'chevrolet ipanema' },
  { label: 'CHEVROLET KADETT', value: 'chevrolet kadett' },
  { label: 'CHEVROLET MALIBU', value: 'chevrolet malibu' },
  { label: 'CHEVROLET MERIVA', value: 'chevrolet meriva' },
  { label: 'CHEVROLET MONTANA', value: 'chevrolet montana' },
  { label: 'CHEVROLET MONZA', value: 'chevrolet monza' },
  { label: 'CHEVROLET OMEGA', value: 'chevrolet omega' },
  { label: 'CHEVROLET ONIX', value: 'chevrolet onix' },
  { label: 'CHEVROLET OPALA', value: 'chevrolet opala' },
  { label: 'CHEVROLET PRISMA', value: 'chevrolet prisma' },
  { label: 'CHEVROLET S10', value: 'chevrolet s10' },
  { label: 'CHEVROLET SILVERADO', value: 'chevrolet silverado' },
  { label: 'CHEVROLET SONIC', value: 'chevrolet sonic' },
  { label: 'CHEVROLET SPACE VAN', value: 'chevrolet space van' },
  { label: 'CHEVROLET SPIN', value: 'chevrolet spin' },
  { label: 'CHEVROLET TIGRA', value: 'chevrolet tigra' },
  { label: 'CHEVROLET TRACKER', value: 'chevrolet tracker' },
  { label: 'CHEVROLET TRAFIC', value: 'chevrolet trafic' },
  { label: 'CHEVROLET TRAILBLAZER', value: 'chevrolet trailblazer' },
  { label: 'CHEVROLET VECTRA', value: 'chevrolet vectra' },
  { label: 'CHEVROLET VERANEIO', value: 'chevrolet veraneio' },
  { label: 'CHEVROLET ZAFIRA', value: 'chevrolet zafira' },
  { label: 'CHRYSLER PT CRUISER', value: 'chrysler pt cruiser' },
  { label: 'CITROEN AIRCROSS', value: 'citroen aircross' },
  { label: 'CITROEN JUMPY', value: 'citroen jumpy' },
  { label: 'CITROEN C3', value: 'citroen c3' },
  { label: 'CITROEN C4', value: 'citroen c4' },
  { label: 'CITROEN C5', value: 'citroen c5' },
  { label: 'CITROEN GRAND C4', value: 'citroen grand c4' },
  { label: 'CITROEN XSARA', value: 'citroen xsara' },
  { label: 'DAFRA APACHE', value: 'dafra apache' },
  { label: 'DAFRA CITYCOM 300', value: 'dafra citycom 300' },
  { label: 'DAFRA KANSAS', value: 'dafra kansas' },
  { label: 'DODGE CHALLENGER', value: 'dodge challenger' },
  { label: 'DODGE DAKOTA', value: 'dodge dakota' },
  { label: 'DODGE GRAND CARAVAN', value: 'dodge grand caravan' },
  { label: 'DODGE JOURNEY', value: 'dodge journey' },
  { label: 'DODGE RAM', value: 'dodge ram' },
  { label: 'DODGE VIPER', value: 'dodge viper' },
  { label: 'FERRARI', value: 'ferrari' },
  { label: 'FIAT 147', value: 'fiat 147' },
  { label: 'FIAT ARGO', value: 'fiat argo' },
  { label: 'FIAT BRAVO', value: 'fiat bravo' },
  { label: 'FIAT CINQUECENTO', value: 'fiat cinquecento' },
  { label: 'FIAT CRONOS', value: 'fiat cronos' },
  { label: 'FIAT DOBLO', value: 'fiat doblo' },
  { label: 'FIAT DUCATO', value: 'fiat ducato' },
  { label: 'FIAT ELBA', value: 'fiat elba' },
  { label: 'FIAT FASTBACK', value: 'fiat fastback' },
  { label: 'FIAT FIORINO', value: 'fiat fiorino' },
  { label: 'FIAT FREEMONT', value: 'fiat freemont' },
  { label: 'FIAT GRAND SIENA', value: 'fiat grand siena' },
  { label: 'FIAT IDEIA', value: 'fiat ideia' },
  { label: 'FIAT LINEA', value: 'fiat linea' },
  { label: 'FIAT MAREA', value: 'fiat marea' },
  { label: 'FIAT MOBI', value: 'fiat mobi' },
  { label: 'FIAT OGGI', value: 'fiat oggi' },
  { label: 'FIAT PALIO', value: 'fiat palio' },
  { label: 'FIAT PREMIO', value: 'fiat premio' },
  { label: 'FIAT PULSE', value: 'fiat pulse' },
  { label: 'FIAT PUNTO', value: 'fiat punto' },
  { label: 'FIAT SIENA', value: 'fiat siena' },
  { label: 'FIAT STILO', value: 'fiat stilo' },
  { label: 'FIAT STRADA', value: 'fiat strada' },
  { label: 'FIAT TEMPRA', value: 'fiat tempra' },
  { label: 'FIAT TIPO', value: 'fiat tipo' },
  { label: 'FIAT TORO', value: 'fiat toro' },
  { label: 'FIAT UNO', value: 'fiat uno' },
  { label: 'FORD BELINA', value: 'ford belina' },
  { label: 'FORD BRONCO', value: 'ford bronco' },
  { label: 'FORD CORCEL', value: 'ford corcel' },
  { label: 'FORD COURIER', value: 'ford courier' },
  { label: 'FORD DEL REY', value: 'ford del rey' },
  { label: 'FORD ECOSPORT', value: 'ford ecosport' },
  { label: 'FORD EDGE', value: 'ford edge' },
  { label: 'FORD ESCORT', value: 'ford escort' },
  { label: 'FORD F150', value: 'ford f150' },
  { label: 'FORD F250', value: 'ford f250' },
  { label: 'FORD FIESTA', value: 'ford fiesta' },
  { label: 'FORD FOCUS', value: 'ford focus' },
  { label: 'FORD FUSION', value: 'ford fusion' },
  { label: 'FORD IBIZA', value: 'ford ibiza' },
  { label: 'FORD JEEP', value: 'ford jeep' },
  { label: 'FORD KA', value: 'ford ka' },
  { label: 'FORD MAVERICK', value: 'ford maverick' },
  { label: 'FORD MONDEO', value: 'ford mondeo' },
  { label: 'FORD MUSTANG', value: 'ford mustang' },
  { label: 'FORD PAMPA', value: 'ford pampa' },
  { label: 'FORD RANGER', value: 'ford ranger' },
  { label: 'FORD ROYALE', value: 'ford royale' },
  { label: 'FORD TERRITORY', value: 'ford territory' },
  { label: 'FORD VERONA', value: 'ford verona' },
  { label: 'FORD VERSALLES', value: 'ford versalles' },
  { label: 'FORD', value: 'ford' },
  { label: 'HARLEY DAVIDSON FAT BOY', value: 'harley davidson fat boy' },
  { label: 'HARLEY DAVIDSON NIGHT TRAIN', value: 'harley davidson night train' },
  { label: 'HARLEY DAVIDSON ROAD KING', value: 'harley davidson road king' },
  { label: 'HARLEY DAVIDSON V ROD', value: 'harley davidson v rod' },
  { label: 'HAVAL H6', value: 'haval h6' },
  { label: 'HONDA 250 TWISTTER', value: 'honda 250 twistter' },
  { label: 'HONDA ACCORD', value: 'honda accord' },
  { label: 'HONDA BIS 100', value: 'honda bis 100' },
  { label: 'HONDA BIS 125', value: 'honda bis 125' },
  { label: 'HONDA BROSS 125', value: 'honda bross 125' },
  { label: 'HONDA BROSS 150', value: 'honda bross 150' },
  { label: 'HONDA BROSS 160', value: 'honda bross 160' },
  { label: 'HONDA CB 1000', value: 'honda cb 1000' },
  { label: 'HONDA CB 300', value: 'honda cb 300' },
  { label: 'HONDA CB 400', value: 'honda cb 400' },
  { label: 'HONDA CB 450', value: 'honda cb 450' },
  { label: 'HONDA CB 500', value: 'honda cb 500' },
  { label: 'HONDA CBR 1000', value: 'honda cbr 1000' },
  { label: 'HONDA CBR 250', value: 'honda cbr 250' },
  { label: 'HONDA CBR 600', value: 'honda cbr 600' },
  { label: 'HONDA CBX 200 STRADA', value: 'honda cbx 200 strada' },
  { label: 'HONDA CG 125 TITAN', value: 'honda cg 125 titan' },
  { label: 'HONDA CG 150 TITAN', value: 'honda cg 150 titan' },
  { label: 'HONDA CG 160 TITAN', value: 'honda cg 160 titan' },
  { label: 'HONDA CITY', value: 'honda city' },
  { label: 'HONDA CIVIC', value: 'honda civic' },
  { label: 'HONDA CRV', value: 'honda crv' },
  { label: 'HONDA FAN 125', value: 'honda fan 125' },
  { label: 'HONDA FAN 150', value: 'honda fan 150' },
  { label: 'HONDA FIT', value: 'honda fit' },
  { label: 'HONDA HORNET', value: 'honda hornet' },
  { label: 'HONDA HRV', value: 'honda hrv' },
  { label: 'HONDA LEAD', value: 'honda lead' },
  { label: 'HONDA NC 700', value: 'honda nc 700' },
  { label: 'HONDA NC FALCON', value: 'honda nc falcon' },
  { label: 'HONDA NX 4 FALCON', value: 'honda nx 4 falcon' },
  { label: 'HONDA ODYSSEY', value: 'honda odyssey' },
  { label: 'HONDA PCX', value: 'honda pcx' },
  { label: 'HONDA POP', value: 'honda pop' },
  { label: 'HONDA SH300', value: 'honda sh300' },
  { label: 'HONDA SHADOW', value: 'honda shadow' },
  { label: 'HONDA TWISTTER', value: 'honda twistter' },
  { label: 'HONDA WRV', value: 'honda wrv' },
  { label: 'HONDA XRE 190', value: 'honda xre 190' },
  { label: 'HONDA XRE 300', value: 'honda xre 300' },
  { label: 'HONDA XRE', value: 'honda xre' },
  { label: 'HYUNDAY AZERA', value: 'hyunday azera' },
  { label: 'HYUNDAY CRETA', value: 'hyunday creta' },
  { label: 'HYUNDAY ELANTRA', value: 'hyunday elantra' },
  { label: 'HYUNDAY EQUUS', value: 'hyunday equus' },
  { label: 'HYUNDAY GRAND SANTA FE', value: 'hyunday grand santa fe' },
  { label: 'HYUNDAY HB20', value: 'hyunday hb20' },
  { label: 'HYUNDAY HB20S', value: 'hyunday hb20s' },
  { label: 'HYUNDAY HB20X', value: 'hyunday hb20x' },
  { label: 'HYUNDAY I30', value: 'hyunday i30' },
  { label: 'HYUNDAY IX35', value: 'hyunday ix35' },
  { label: 'HYUNDAY SANTA FE', value: 'hyunday santa fe' },
  { label: 'HYUNDAY SONATA', value: 'hyunday sonata' },
  { label: 'HYUNDAY TUCSON', value: 'hyunday tucson' },
  { label: 'HYUNDAY VELOSTER', value: 'hyunday veloster' },
  { label: 'HYUNDAY VERA CRUZ', value: 'hyunday vera cruz' },
  { label: 'JAC MOTORS J2', value: 'jac motors j2' },
  { label: 'JAC MOTORS J3', value: 'jac motors j3' },
  { label: 'JAC MOTORS J5', value: 'jac motors j5' },
  { label: 'JAC MOTORS J6', value: 'jac motors j6' },
  { label: 'JAC MOTORS T5', value: 'jac motors t5' },
  { label: 'JAC MOTORS T6', value: 'jac motors t6' },
  { label: 'JAC MOTORS T8', value: 'jac motors t8' },
  { label: 'JAGUAR', value: 'jaguar' },
  { label: 'JEEP CHEROKEE', value: 'jeep cherokee' },
  { label: 'JEEP COMPASS', value: 'jeep compass' },
  { label: 'JEEP RENEGADE', value: 'jeep renegade' },
  { label: 'JINBEI TOPIC', value: 'jinbei topic' },
  { label: 'KASINSKI COMET 250', value: 'kasinski comet 250' },
  { label: 'KASINSKI COMET', value: 'kasinski comet' },
  { label: 'KASINSKI MIRAGE', value: 'kasinski mirage' },
  { label: 'KASINSKI PRIMA', value: 'kasinski prima' },
  { label: 'KAWASAKI ER-6N', value: 'kawasaki er-6n' },
  { label: 'KAWASAKI KX 100', value: 'kawasaki kx 100' },
  { label: 'KAWASAKI NINJA 1000', value: 'kawasaki ninja 1000' },
  { label: 'KAWASAKI NINJA 250', value: 'kawasaki ninja 250' },
  { label: 'KAWASAKI NINJA 300', value: 'kawasaki ninja 300' },
  { label: 'KAWASAKI NINJA ZX 10', value: 'kawasaki ninja zx 10' },
  { label: 'KAWASAKI NINJA ZX 11', value: 'kawasaki ninja zx 11' },
  { label: 'KAWASAKI NINJA ZX 14', value: 'kawasaki ninja zx 14' },
  { label: 'KAWASAKI VULCAN', value: 'kawasaki vulcan' },
  { label: 'KAWASAKI Z1000', value: 'kawasaki z1000' },
  { label: 'KAWASAKI Z300', value: 'kawasaki z300' },
  { label: 'KAWASAKI Z650', value: 'kawasaki z650' },
  { label: 'KAWASAKI Z750', value: 'kawasaki z750' },
  { label: 'KAWASAKI Z800', value: 'kawasaki z800' },
  { label: 'KIA BESTA', value: 'kia besta' },
  { label: 'KIA CARNIVAL', value: 'kia carnival' },
  { label: 'KIA CERATO', value: 'kia cerato' },
  { label: 'KIA EV 6', value: 'kia ev 6' },
  { label: 'KIA OPTIMA', value: 'kia optima' },
  { label: 'KIA PICANTO', value: 'kia picanto' },
  { label: 'KIA SORENTO', value: 'kia sorento' },
  { label: 'KIA SOUL', value: 'kia soul' },
  { label: 'KIA SPORTAGE', value: 'kia sportage' },
  { label: 'KIA STONIC', value: 'kia stonic' },
  { label: 'LAMBORGHINI', value: 'lamborghini' },
  { label: 'LAND ROVER DISCOVERY', value: 'land rover discovery' },
  { label: 'LAND ROVER EVOQUE', value: 'land rover evoque' },
  { label: 'LAND ROVER FREELANDER', value: 'land rover freelander' },
  { label: 'LAND ROVER RANGE ROVER', value: 'land rover range rover' },
  { label: 'MASERATI', value: 'maserati' },
  { label: 'MERCEDES BENZ', value: 'mercedes benz' },
  { label: 'MERCEDES CLASSE A', value: 'mercedes classe a' },
  { label: 'MERCEDES MICROONIBUS', value: 'mercedes microonibus' },
  { label: 'MERCEDES SPRINTER', value: 'mercedes sprinter' },
  { label: 'MERCEDES', value: 'mercedes' },
  { label: 'MINI COOPER', value: 'mini cooper' },
  { label: 'MITSUBISHI ASX', value: 'mitsubishi asx' },
  { label: 'MITSUBISHI ECLIPSE', value: 'mitsubishi eclipse' },
  { label: 'MITSUBISHI L200', value: 'mitsubishi l200' },
  { label: 'MITSUBISHI LANCER', value: 'mitsubishi lancer' },
  { label: 'MITSUBISHI MIRAGE', value: 'mitsubishi mirage' },
  { label: 'MITSUBISHI OUTLANDER', value: 'mitsubishi outlander' },
  { label: 'MITSUBISHI PAJERO', value: 'mitsubishi pajero' },
  { label: 'MITSUBISHI SPACE WAGON', value: 'mitsubishi space wagon' },
  { label: 'NISSAN 350Z', value: 'nissan 350z' },
  { label: 'NISSAN ALTIMA', value: 'nissan altima' },
  { label: 'NISSAN FRONTIER', value: 'nissan frontier' },
  { label: 'NISSAN GRAND LIVINA', value: 'nissan grand livina' },
  { label: 'NISSAN KICKS', value: 'nissan kicks' },
  { label: 'NISSAN LIVINA', value: 'nissan livina' },
  { label: 'NISSAN MARCH', value: 'nissan march' },
  { label: 'NISSAN SENTRA', value: 'nissan sentra' },
  { label: 'NISSAN TIDA', value: 'nissan tida' },
  { label: 'NISSAN VERSA', value: 'nissan versa' },
  { label: 'PEUGEOT 2008', value: 'peugeot 2008' },
  { label: 'PEUGEOT 206', value: 'peugeot 206' },
  { label: 'PEUGEOT 207', value: 'peugeot 207' },
  { label: 'PEUGEOT 208', value: 'peugeot 208' },
  { label: 'PEUGEOT 3008', value: 'peugeot 3008' },
  { label: 'PEUGEOT 306', value: 'peugeot 306' },
  { label: 'PEUGEOT 307', value: 'peugeot 307' },
  { label: 'PEUGEOT 308', value: 'peugeot 308' },
  { label: 'PEUGEOT 405', value: 'peugeot 405' },
  { label: 'PEUGEOT 406', value: 'peugeot 406' },
  { label: 'PEUGEOT 407', value: 'peugeot 407' },
  { label: 'PEUGEOT 408', value: 'peugeot 408' },
  { label: 'PEUGEOT 508', value: 'peugeot 508' },
  { label: 'PEUGEOT BOXER', value: 'peugeot boxer' },
  { label: 'PEUGEOT HOGGAR', value: 'peugeot hoggar' },
  { label: 'PORCSHE', value: 'porcshe' },
  { label: 'RENAUT CAPTUR', value: 'renaut captur' },
  { label: 'RENAUT CLIO', value: 'renaut clio' },
  { label: 'RENAUT DUSTER', value: 'renaut duster' },
  { label: 'RENAUT FLUENCE', value: 'renaut fluence' },
  { label: 'RENAUT GRAND SCENIC', value: 'renaut grand scenic' },
  { label: 'RENAUT KANGOO', value: 'renaut kangoo' },
  { label: 'RENAUT KWID', value: 'renaut kwid' },
  { label: 'RENAUT LOGAN', value: 'renaut logan' },
  { label: 'RENAUT MEGANE', value: 'renaut megane' },
  { label: 'RENAUT SANDERO', value: 'renaut sandero' },
  { label: 'RENAUT SCENIC', value: 'renaut scenic' },
  { label: 'RENAUT SYMBOL', value: 'renaut symbol' },
  { label: 'RENAUT TWINGO', value: 'renaut twingo' },
  { label: 'SCANIA', value: 'scania' },
  { label: 'SHINERAY JET', value: 'shineray jet' },
  { label: 'SMART FORTWO', value: 'smart fortwo' },
  { label: 'SUBARU', value: 'subaru' },
  { label: 'SUNDOWN MAX', value: 'sundown max' },
  { label: 'SUNDOWN VBLADE', value: 'sundown vblade' },
  { label: 'SUZUKI BANDIT 1250', value: 'suzuki bandit 1250' },
  { label: 'SUZUKI BANDIT 650', value: 'suzuki bandit 650' },
  { label: 'SUZUKI BANDIT', value: 'suzuki bandit' },
  { label: 'SUZUKI BKING', value: 'suzuki bking' },
  { label: 'SUZUKI BOULEVARD', value: 'suzuki boulevard' },
  { label: 'SUZUKI BURGMAN', value: 'suzuki burgman' },
  { label: 'SUZUKI GS500', value: 'suzuki gs500' },
  { label: 'SUZUKI GSX R750', value: 'suzuki gsx r750' },
  { label: 'SUZUKI HAYABUSA', value: 'suzuki hayabusa' },
  { label: 'SUZUKI INTRUDER', value: 'suzuki intruder' },
  { label: 'SUZUKI V STROM', value: 'suzuki v strom' },
  { label: 'SUZUKI YES', value: 'suzuki yes' },
  { label: 'TOYOTA CAMRY', value: 'toyata camry' }, // (mantive como veio; se quiser corrijo para 'toyota camry')
  { label: 'TOYOTA COROLLA', value: 'toyota corolla' },
  { label: 'TOYOTA ETIOS', value: 'toyota etios' },
  { label: 'TOYOTA FIELDER', value: 'toyota fielder' },
  { label: 'TOYOTA HILUX', value: 'toyota hilux' },
  { label: 'TOYOTA PRIUS', value: 'toyota prius' },
  { label: 'TOYOTA RAV4', value: 'toyota rav4' },
  { label: 'TOYOTA SIENNA', value: 'toyota sienna' },
  { label: 'TOYOTA TUNDRA', value: 'toyota tundra' },
  { label: 'TOYOTA YARIS', value: 'toyota yaris' },
  { label: 'TRIUMPH DAYTONA', value: 'triumph daytona' },
  { label: 'TRIUMPH ROCKET 3', value: 'triumph rocket 3' },
  { label: 'TRIUMPH SPEED TRIPLE', value: 'triumph speed triple' },
  { label: 'TRIUMPH STREET TRIPLE', value: 'triumph street triple' },
  { label: 'TRIUMPH TIGER', value: 'triumph tiger' },
  { label: 'TROLLER', value: 'troller' },
  { label: 'VAN', value: 'van' },
  { label: 'VOLKS', value: 'volks' },
  { label: 'VOLKSWAGEN AMAROK', value: 'volkswagen amarok' },
  { label: 'VOLKSWAGEN APOLLO', value: 'volkswagen apollo' },
  { label: 'VOLKSWAGEN BRASILIA', value: 'volkswagen brasilia' },
  { label: 'VOLKSWAGEN CROSS FOX', value: 'volkswagen cross fox' },
  { label: 'VOLKSWAGEN CROSS UP', value: 'volkswagen cross up' },
  { label: 'VOLKSWAGEN FOX', value: 'volkswagen fox' },
  { label: 'VOLKSWAGEN FUSCA', value: 'volkswagen fusca' },
  { label: 'VOLKSWAGEN GOL', value: 'volkswagen gol' },
  { label: 'VOLKSWAGEN GOLF', value: 'volkswagen golf' },
  { label: 'VOLKSWAGEN JETTA', value: 'volkswagen jetta' },
  { label: 'VOLKSWAGEN KOMBI', value: 'volkswagen kombi' },
  { label: 'VOLKSWAGEN LOGUS', value: 'volkswagen logus' },
  { label: 'VOLKSWAGEN NEW BEETLE', value: 'volkswagen new beetle' },
  { label: 'VOLKSWAGEN NIVUS', value: 'volkswagen nivus' },
  { label: 'VOLKSWAGEN PARATI', value: 'volkswagen parati' },
  { label: 'VOLKSWAGEN PASSAT VARIANT', value: 'volkswagen passat variant' },
  { label: 'VOLKSWAGEN PASSAT', value: 'volkswagen passat' },
  { label: 'VOLKSWAGEN POLO SEDAN', value: 'volkswagen polo sedan' },
  { label: 'VOLKSWAGEN POLO', value: 'volkswagen polo' },
  { label: 'VOLKSWAGEN QUANTUN', value: 'volkswagen quantun' },
  { label: 'VOLKSWAGEN SANTANA', value: 'volkswagen santana' },
  { label: 'VOLKSWAGEN SAVEIRO', value: 'volkswagen saveiro' },
  { label: 'VOLKSWAGEN SPACE CROSS', value: 'volkswagen space cross' },
  { label: 'VOLKSWAGEN SPACE FOX', value: 'volkswagen space fox' },
  { label: 'VOLKSWAGEN TAOS', value: 'volkswagen taos' },
  { label: 'VOLKSWAGEN T CROSS', value: 'volkswagen t cross' },
  { label: 'VOLKSWAGEN TIGUAN', value: 'volkswagen tiguan' },
  { label: 'VOLKSWAGEN UP', value: 'volkswagen up' },
  { label: 'VOLKSWAGEN VARIANT', value: 'volkswagen variant' },
  { label: 'VOLKSWAGEN VIRTUS', value: 'volkswagen virtus' },
  { label: 'VOLKSWAGEN VOYAGE', value: 'volkswagen voyage' },
  { label: 'VOLVO S60', value: 'volvo s60' },
  { label: 'VOLVO XC60', value: 'volvo xc60' },
  { label: 'VOLVO', value: 'volvo' },
  { label: 'YAMAHA DRAG STAR', value: 'yamaha drag star' },
  { label: 'YAMAHA FACTOR', value: 'yamaha factor' },
  { label: 'YAMAHA FAZER', value: 'yamaha fazer' },
  { label: 'YAMAHA MT01', value: 'yamaha mt01' },
  { label: 'YAMAHA MT03', value: 'yamaha mt03' },
  { label: 'YAMAHA MT07', value: 'yamaha mt07' },
  { label: 'YAMAHA MT09', value: 'yamaha mt09' },
  { label: 'YAMAHA NEO', value: 'yamaha neo' },
  { label: 'YAMAHA V MAX', value: 'yamaha v max' },
  { label: 'YAMAHA VIRAGO', value: 'yamaha virago' },
  { label: 'YAMAHA XJ6', value: 'yamaha xj6' },
  { label: 'YAMAHA XT660', value: 'yamaha xt660' },
  { label: 'YAMAHA XTZ 125', value: 'yamaha xtz 125' },
  { label: 'YAMAHA XTZ LANDER', value: 'yamaha xtz lander' },
  { label: 'YAMAHA YBR 125', value: 'yamaha ybr 125' },
  { label: 'YAMAHA YZF R1', value: 'yamaha yzf r1' },
  { label: 'YAMAHA YZF R3', value: 'yamaha yzf r3' },
  { label: 'YAMAHA YZF R6', value: 'yamaha yzf r6' },
  { label: 'YAMAHA YZF', value: 'yamaha yzf' },
];

const vehicleColors = [
  { label: 'Amarela', value: 'AMARELA' },
  { label: 'Azul', value: 'AZUL' },
  { label: 'Bege', value: 'BEGE' },
  { label: 'Bordô', value: 'BORDO' },
  { label: 'Branca', value: 'BRANCA' },
  { label: 'Champagne', value: 'CHAMPAGNE' },
  { label: 'Cinza', value: 'CINZA' },
  { label: 'Dourada', value: 'DOURADA' },
  { label: 'Grafite', value: 'GRAFITE' },
  { label: 'Laranja', value: 'LARANJA' },
  { label: 'Marrom', value: 'MARROM' },
  { label: 'Ouro', value: 'OURO' },
  { label: 'Prata', value: 'PRATA' },
  { label: 'Preta', value: 'PRETA' },
  { label: 'Rosa', value: 'ROSA' },
  { label: 'Roxa', value: 'ROXA' },
  { label: 'Verde', value: 'VERDE' },
  { label: 'Vermelha', value: 'VERMELHA' },
];

function ParkingCallRadioShop() {
  const { path } = useRouteMatch();
  const history = useHistory();
  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(null);

  const redirectToHome = () => {
    history.push(`/${path.split('/')[1]}`);
  };

  const handleSubmit = async (values, { setErrors, resetForm }) => {
    setSubmitError(null);

    try {
      await apiClient.realtimeParkingCallRadioShop(values);
      setSubmitSuccess('Chamada enviada com sucesso.');
      resetForm();
      redirectToHome();
    } catch (error) {
      const [errorMessage, errorDetails] = parseRequestError(error);
      if (errorDetails) {
        setErrors(errorDetails);
      } else {
        setSubmitError(errorMessage);
      }
    }
  };

  const handleCloseSnackbar = () => {
    setSubmitSuccess(null);
  };

  return (
    <div>
      <PageHeader title="Estacionamento" />
      <div className="p-6">
        <Snackbar open={Boolean(submitSuccess)} onClose={handleCloseSnackbar}>
          <Alert type="success" className="shadow-md">
            {submitSuccess}
          </Alert>
        </Snackbar>
        <div className="max-w-2xl mx-auto">
          <Formik
            initialValues={{
              vehicleType: '',
              vehicleBrand: '',
              vehicleColor: '',
              licensePlate: '',
              repeat: false,
            }}
            validationSchema={Yup.object({
              vehicleType: Yup.string().required('Campo obrigatório.'),
              vehicleBrand: Yup.string().required('Campo obrigatório.'),
              vehicleColor: Yup.string().required('Campo obrigatório.'),
              licensePlate: Yup.string().required('Campo obrigatório.'),
              repeat: Yup.boolean().required('Campo obrigatório.'),
            })}
            onSubmit={handleSubmit}
          >
            <Form noValidate autoComplete="off">
              <SelectField name="vehicleType">
                <option value="">Selecione um tipo do veículo</option>
                {vehicleTypes.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </SelectField>
              <SelectField name="vehicleBrand">
                <option value="">Selecione uma marca</option>
                {vehicleBrands.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </SelectField>
              <SelectField name="vehicleColor">
                <option value="">Selecione uma cor</option>
                {vehicleColors.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </SelectField>
              <InputField
                name="licensePlate"
                placeholder="Insira a placa"
                mask="***-****"
              />
              <div className="flex items-center justify-between mb-5">
                <ToggleField name="repeat" label="Repetir aviso" noMargin />
                <Button type="submit" color="primary">
                  Chamar
                </Button>
              </div>
              <div className="mb-5">
                {submitError ? <Alert type="error">{submitError}</Alert> : null}
              </div>
            </Form>
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default ParkingCallRadioShop;
